export const actions = {
  set: 'SET::MANAGEPROJECT'
}

export const setProjectToManage = project => ({ type: actions.set, projectToManage: project })
export const getProjectToManage = state => state.projectToManage

export default actions